<template>
  <section class="black">
    <b-container class="black explorer">
      <b-row>
        <div class="col-sm-12 col-md-8 images">
          <b-carousel
            ref="prototypeCarousel"
            class="prototype-image"
            no-animation
            img-height="800"
            interval="999999"
            v-model="imageID"
          >
            <b-carousel-slide
              v-for="i in images"
              v-bind:key="i.id"
              :img-src="i.image.image.url"
            ></b-carousel-slide>
          </b-carousel>
        </div>
        <div class="col-sm-12 col-md-4 description">
          <div>
            <h4 class="prototype-title">{{ prototype.image.ozgService }}</h4>
            <p class="prototype-artist">
              {{ prototype.image.creationDate.substring(0, 4) }}, 🧑‍🎨
              <a :href="prototype.image.madeBy.website">
                {{ prototype.image.madeBy.name }}</a
              >
            </p>

            <p>{{ prototype.image.description }}</p>
            <p class="prototype-link">
              <a :href="prototype.image.url" target="_blank">zum Exponat</a>
            </p>

            <p class="navigation">
              <a v-on:click="$refs.prototypeCarousel.prev()">⬅️</a>
              <a v-on:click="$refs.prototypeCarousel.next()"> ➡️</a>
            </p>
          </div>
        </div>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "PrototypeGallery",
  props: ["images"],
  data: function() {
    return {
      imageID: 0,
      prototype: this.$props.images[0],
      images_: this.$props.images
    };
  },
  watch: {
    imageID: function(newValue) {
      this.prototype = this.images_[newValue];
    }
  }
};
</script>

<style scoped lang="scss">
.black {
  background-color: #111;
  color: #fff;
  min-height: 90vh;
  padding-top: 5vh;
  padding-bottom: 5vh;
}

.images {
  margin-bottom: 2vh;
}

.description {
  margin: auto;
  @media (min-height: 992px) {
    height: 100%;
  }
}
.prototype-image {
}
.prototype-title {
  @media (max-width: 992px) {
    font-size: 1.5rem;
  }
  font-size: 2.5rem;
  font-family: "Bitter", serif;
}

.prototype-artist {
  font-style: italic;
}

p {
  a {
    color: #fff;
    text-decoration: underline;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
  a:hover {
    color: #fff;
    font-weight: 800;
    letter-spacing: 0;
  }
}

.navigation {
  font-size: 4rem;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}
.images {
  @media (min-width: 992px) {
    min-height: 80vh;
  }
}
</style>
